module.exports = __webpack_public_path__ + "static/media/planA.c80add0e.jpg";